var _style;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 200",
    style: {
      enableBackground: "new 0 0 400 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style131"
  }, "\n\t.st0{enable-background:new    ;}\n\t.st1{fill:#00BBFF;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title133"
  }, "Logo Genelead") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title133"
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "st0",
    id: "g173",
    style: {
      fill: "#ffffff"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2,148.9h11.5v2.6H15v-24.2h3.2V148.9z",
    id: "path135",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9,140.3H34.5v8.6h12.2v2.6H31.3v-24.2h15.2v2.6h-12v7.8h10.5V140.3z",
    id: "path137",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8,148.3c-0.8,1.2-2,2-3.4,2.6c-1.5,0.6-3.2,0.9-5.1,0.9c-2,0-3.7-0.5-5.2-1.4c-1.5-0.9-2.7-2.2-3.5-3.9   c-0.8-1.7-1.3-3.7-1.3-5.9v-2.1c0-3.6,0.8-6.5,2.5-8.5c1.7-2,4.1-3,7.2-3c2.5,0,4.6,0.6,6.1,1.9c1.5,1.3,2.5,3.1,2.8,5.5h-3.2   c-0.6-3.2-2.5-4.8-5.7-4.8c-2.1,0-3.8,0.8-4.9,2.3c-1.1,1.5-1.7,3.7-1.7,6.5v2c0,2.7,0.6,4.9,1.9,6.5c1.2,1.6,2.9,2.4,5,2.4   c1.2,0,2.2-0.1,3.1-0.4c0.9-0.3,1.6-0.7,2.2-1.3v-5.4H64v-2.6h8.8V148.3z",
    id: "path139",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7,140.3H79.3v8.6h12.2v2.6H76.1v-24.2h15.2v2.6h-12v7.8h10.5V140.3z",
    id: "path141",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.9,151.5h-3.2l-12.2-18.6v18.6h-3.2v-24.2h3.2l12.2,18.7v-18.7h3.2V151.5z",
    id: "path143",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.2,140.3h-10.5v8.6h12.2v2.6h-15.4v-24.2h15.2v2.6h-12v7.8h10.5V140.3z",
    id: "path145",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.7,141.7H136v9.8h-3.2v-24.2h8c2.7,0,4.8,0.6,6.3,1.9c1.5,1.2,2.2,3,2.2,5.4c0,1.5-0.4,2.8-1.2,3.9s-1.9,2-3.4,2.5   l5.7,10.3v0.2h-3.4L141.7,141.7z M136,139.1h4.9c1.6,0,2.8-0.4,3.8-1.2c0.9-0.8,1.4-1.9,1.4-3.3c0-1.5-0.4-2.6-1.3-3.4   c-0.9-0.8-2.2-1.2-3.9-1.2H136V139.1z",
    id: "path147",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.1,145.2h-10.1l-2.3,6.3h-3.3l9.2-24.2h2.8l9.2,24.2h-3.3L165.1,145.2z M155.9,142.6h8.2l-4.1-11.3L155.9,142.6z",
    id: "path149",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.4,129.9h-7.8v21.6h-3.2v-21.6h-7.8v-2.6h18.7V129.9z",
    id: "path151",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.6,140.3h-10.5v8.6h12.2v2.6H188v-24.2h15.2v2.6h-12v7.8h10.5V140.3z",
    id: "path153",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.3,127.3v16.4c0,2.3-0.7,4.1-2.2,5.6s-3.4,2.3-5.8,2.4l-0.8,0c-2.6,0-4.8-0.7-6.3-2.1c-1.6-1.4-2.4-3.4-2.4-5.9v-16.5   h3.2v16.4c0,1.7,0.5,3.1,1.4,4.1c1,1,2.3,1.5,4.1,1.5c1.8,0,3.2-0.5,4.1-1.4s1.4-2.3,1.4-4.1v-16.4H222.3z",
    id: "path155",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.1,141.7h-5.7v9.8h-3.2v-24.2h8c2.7,0,4.8,0.6,6.3,1.9s2.2,3,2.2,5.4c0,1.5-0.4,2.8-1.2,3.9s-1.9,2-3.4,2.5l5.7,10.3   v0.2h-3.4L234.1,141.7z M228.5,139.1h4.9c1.6,0,2.8-0.4,3.8-1.2s1.4-1.9,1.4-3.3c0-1.5-0.4-2.6-1.3-3.4c-0.9-0.8-2.2-1.2-3.9-1.2   h-4.9V139.1z",
    id: "path157",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.5,151.5v-24.2h6.8c2.1,0,4,0.5,5.6,1.4c1.6,0.9,2.9,2.3,3.7,4s1.3,3.7,1.3,5.9v1.5c0,2.3-0.4,4.3-1.3,6s-2.1,3-3.8,4   s-3.5,1.4-5.7,1.4H250.5z M253.7,129.9v19h3.4c2.5,0,4.4-0.8,5.7-2.3s2.1-3.7,2.1-6.5v-1.4c0-2.7-0.6-4.9-1.9-6.4   c-1.3-1.5-3.1-2.3-5.5-2.3H253.7z",
    id: "path159",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.5,140.3H274v8.6h12.2v2.6h-15.4v-24.2H286v2.6h-12v7.8h10.5V140.3z",
    id: "path161",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.7,148.9h11.5v2.6h-14.7v-24.2h3.2V148.9z",
    id: "path163",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.4,140.3h-10.5v8.6h12.2v2.6h-15.4v-24.2h15.2v2.6h-12v7.8h10.5V140.3z",
    id: "path165",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.3,145.2h-10.1l-2.3,6.3h-3.3l9.2-24.2h2.8l9.2,24.2h-3.3L341.3,145.2z M332.2,142.6h8.2l-4.1-11.3L332.2,142.6z",
    id: "path167",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.1,151.5v-24.2h6.8c2.1,0,4,0.5,5.6,1.4s2.9,2.3,3.7,4c0.9,1.7,1.3,3.7,1.3,5.9v1.5c0,2.3-0.4,4.3-1.3,6   c-0.9,1.7-2.1,3-3.8,4c-1.6,0.9-3.5,1.4-5.7,1.4H348.1z M351.3,129.9v19h3.4c2.5,0,4.4-0.8,5.7-2.3c1.4-1.5,2.1-3.7,2.1-6.5v-1.4   c0-2.7-0.6-4.9-1.9-6.4c-1.3-1.5-3.1-2.3-5.5-2.3H351.3z",
    id: "path169",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.5,140.7c-2.7-0.8-4.7-1.8-6-2.9c-1.2-1.1-1.9-2.6-1.9-4.2c0-1.9,0.8-3.5,2.3-4.7c1.5-1.2,3.5-1.9,5.9-1.9   c1.7,0,3.1,0.3,4.4,1c1.3,0.6,2.3,1.5,3,2.7c0.7,1.1,1.1,2.4,1.1,3.7h-3.2c0-1.5-0.5-2.6-1.4-3.5c-0.9-0.8-2.2-1.3-3.9-1.3   c-1.6,0-2.8,0.3-3.7,1c-0.9,0.7-1.3,1.7-1.3,2.9c0,1,0.4,1.8,1.3,2.5c0.8,0.7,2.3,1.3,4.3,1.9c2,0.6,3.6,1.2,4.7,1.9   c1.1,0.7,2,1.5,2.5,2.4c0.5,0.9,0.8,2,0.8,3.2c0,2-0.8,3.5-2.3,4.7c-1.5,1.2-3.6,1.8-6.1,1.8c-1.7,0-3.2-0.3-4.6-1   c-1.4-0.6-2.5-1.5-3.3-2.6c-0.8-1.1-1.2-2.4-1.2-3.8h3.2c0,1.5,0.5,2.6,1.6,3.5c1.1,0.8,2.5,1.3,4.3,1.3c1.7,0,3-0.3,3.9-1   s1.3-1.6,1.3-2.8s-0.4-2.1-1.2-2.7C379.2,142,377.7,141.4,375.5,140.7z",
    id: "path171",
    style: {
      fill: "#ffffff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g191"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.4,102.6c-1.6,2.3-4.2,4.4-7.9,6.2c-3.7,1.9-8.4,2.8-14.1,2.8c-7.3,0-13.2-2.3-17.9-6.9   c-4.7-4.6-7.1-10.5-7.1-17.8V74.3c0-7.3,2.2-13.2,6.6-17.8s10.2-6.9,17.2-6.9c7.1,0,12.6,1.7,16.6,5.2c3.9,3.4,6.1,8.4,6,13.7   l-0.1,0.2h-9.5c-0.1-3-1.4-5.9-3.5-8c-2.1-2-5.2-3-9.3-3c-3.9-0.1-7.7,1.6-10.1,4.7c-2.6,3.4-4,7.6-3.8,11.9v12.6   c-0.2,4.4,1.3,8.7,4.2,12c2.7,3.1,6.7,4.8,10.8,4.7c2.6,0.1,5.2-0.3,7.7-1.1c1.6-0.5,3.1-1.4,4.3-2.6V87.7H33.4v-7.5h22V102.6z",
    id: "path175",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.5,83.7H73.1v19.1h30.6v8.1H63V50.5h40.4v8.1H73.1v17h26.4L99.5,83.7z",
    id: "path177",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M154.5,110.8h-10l-26.8-44l-0.2,0.1v44h-10.1V50.5h10.1l26.8,44l0.2-0.1V50.5h10L154.5,110.8z",
    id: "path179",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M199.4,83.7h-26.4v19.1h30.6v8.1H163V50.5h40.4v8.1h-30.4v17h26.4V83.7z",
    id: "path181",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.5,102.7h27.7v8.1h-37.8V50.5h10.1L217.5,102.7z",
    id: "path183",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,83.7h-26.4v19.1h30.6v8.1h-40.7V50.5H289v8.1h-30.3v17H285L285,83.7z",
    id: "path185",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.9,110.8V50.5h19.5c7.6,0,13.9,2.4,18.7,7.2s7.2,10.9,7.2,18.4v9.2c0,7.5-2.4,13.7-7.2,18.4s-11,7.1-18.7,7.1H342.9z    M353,58.6v44.2h9.2c5,0,8.9-1.6,11.8-4.9c2.9-3.3,4.3-7.5,4.3-12.6V76c0-5.1-1.4-9.3-4.3-12.5c-2.9-3.3-6.8-4.9-11.8-4.9L353,58.6   z",
    id: "path187",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.6,50.5 308.1,50.5 285.9,110.8 296.1,110.8 300.9,96.7 300.9,96.7 305.5,83.3 305.5,83.3 312.7,62.5    312.9,62.5 321.6,88.3 311.1,88.3 308.3,96.7 324.5,96.7 329.3,110.8 339.5,110.8  ",
    id: "polygon189",
    style: {
      fill: "#ffffff"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.78ada9d67c2c208dd63df9affa522328.svg";
export { ForwardRef as ReactComponent };